import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Default, Organization, Account } from '../../shared/sdk/models';

import { OrganizationService } from '../../organizations/organization.service';
import { take, takeUntil, filter } from 'rxjs/operators';
import { AccountService } from '../../accounts/account.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-default-edit-text',
  templateUrl: './default-edit-text.component.html',
  styleUrls: ['./default-edit-text.component.css'],
})
export class DefaultEditTextComponent implements OnInit, OnDestroy {
  @Input() type: string;
  @Input() typeName: string;
  account: Account;
  activeOrg: Organization;
  default: Default;
  loading: boolean;
  sent: boolean;
  textForm: FormGroup;
  private onDestroy = new Subject<void>();

  constructor(
    private activeModal: NgbActiveModal,
    private accountService: AccountService,
    private orgService: OrganizationService,
    private translate: TranslateService,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.sent = false;

    // Form control
    this.textForm = this.fb.group({
      id: ['', Validators.required],
      value: [''],
    });

    this.translate
      .get(this.typeName)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((res) => (this.typeName = res));

    this.orgService.active
      .pipe(
        filter((org) => !!org),
        takeUntil(this.onDestroy),
      )
      .subscribe((org: Organization) => {
        this.activeOrg = org;

        // Load default text based on passed type
        this.default = this.activeOrg._defaults.find(
          (d: Default) => d.name === this.type,
        );

        if (typeof this.default !== 'undefined') {
          this.textForm.controls.id.setValue(this.default.id);
          this.textForm.controls.value.setValue(this.default.value);
        }
      });

    this.accountService.active
      .pipe(takeUntil(this.onDestroy))
      .subscribe((account) => (this.account = account));
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  onClose(): void {
    this.activeModal.close();
  }

  onSave(): void {
    this.sent = true;

    if (this.textForm.valid) {
      this.default.id = this.textForm.controls.id.value;
      this.default.value = this.textForm.value.value;

      this.orgService.updateDefault(this.activeOrg, this.default).subscribe(
        () => {},
        () => {},
      );
      this.activeModal.close();
    }
  }
}
